_ = require 'underscore'
Confirm = require 'app/scripts/views/lib/confirm'
CustomFieldItem = require 'app/scripts/models/custom-field-item'
{ isSubmitEvent } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
Util = require 'app/scripts/lib/util'
t = require('app/scripts/views/internal/teacup-with-helpers')('custom_fields')

MAX_OPTIONS = 50

template = t.renderable ({ options, colors }) ->
  t.div ->
    t.label '.js-option-list-label', -> t.format 'options'
    t.div '.js-option-list', ->
      options.map (o) ->
        t.div '.field-list-option.js-list-option', { idOption: o.cid || o.id }, ->
          t.a '.field-list-option-color-swatch.is-clickable.js-option-pick-color.field-color-' + (o.color || 'none'), { href: '#' }
          t.a '.option-value.js-option', { href: '#', title: o.value.text }, -> t.text o.value.text
          t.input '.option-value.js-option', { type: 'text', value: o.value.text }
          t.a '.icon-sm.icon-trash.js-remove-option', { href: '#' }
    t.div '.hide.js-option-color-picker', ->
      t.label '.field-color-picker-label', -> t.format 'select a color'
      t.div { style: 'margin-left: 4px' }, ->
        colors.map (c) ->
          t.a ".field-list-option-color-swatch.field-color.is-clickable.field-color-#{c.color}.js-palette-color", { 'data-color': c.color }
    if options.length < MAX_OPTIONS
      t.input '.js-add-option', { type: 'text', placeholder: t.l('add item') }

module.exports = class OptionsEditorView extends View
  initialize: ->
    @customField = @options.customField
    @options = @customField?.get('options') ? []

  events:
    'click .js-option-pick-color': 'toggleColorPicker'
    'click .js-palette-color': 'pickColor'
    'click a.js-option': 'startEditOption'
    'click .js-remove-option': 'removeOption'
    'keydown .js-add-option': 'addOption'
    'keydown input[type=text].js-option': 'blurOnEnter'
    'focusout input[type=text].js-option': 'updateOption'

  render: ->
    colors = for color in CustomFieldItem.colors
      { color }
    options = @options
    if @customField
      options = @customField.optionList.models.map (o) ->
        _.extend { cid: o.cid }, o.toJSON()

    @$el.html template({ colors, options })
    $optionList = @$('.js-option-list')

    if options.length > 1
      $optionList.sortable
        axis: 'y'
        cursor: 'move'
        delay: '75'
        distance: '5'
        tolerance: 'pointer'
        placeholder: 'field-list-option placeholder'
        items: '.js-list-option'
        sort: (event, ui) =>
          formTop = @$el.closest('.js-options-container').parent().offset().top
          labelHeight = @$el.find('.js-option-list-label').first().outerHeight()
          top = event.clientY - formTop - labelHeight
          ui.helper.css({ top: "#{top}px" })
        update: (event, ui) =>
          idOption = ui.item.attr('idOption')
          newIndex = ui.item.parent().children().index(ui.item)
          if @customField
            @customField.getOptionByCId(idOption).move(newIndex)
          else
            oldIndex = _.findIndex @options, (o) -> o.id == idOption
            # https://stackoverflow.com/a/7180095
            @options.splice(newIndex, 0, @options.splice(oldIndex, 1)[0])

    @

  getOption: (id) -> _.find @options, (o) -> o.id == id

  getOptions: ->
    @options.map (o, i) ->
      if o.new
        { color: o.color, value: o.value, pos: (i + 1) * 1024 }
      else
        _.omit(o, 'pos', 'idCustomField')

  toggleColorPicker: (e) ->
    $picker = @$('.js-option-color-picker')
    if !$picker.hasClass('hide')
      @render()
      return
    $opt = @$(e.target).closest('.js-list-option')
    if $opt.hasClass('editing')
      $opt.children('input.js-option').blur()
      return

    idOption = $opt.attr('idOption')
    @targetOption = idOption

    $picker
    .insertAfter('.js-list-option[idOption="' + idOption + '"]')
    .removeClass('hide')

  pickColor: (e) ->
    color = e.target.dataset.color
    idOption = @targetOption
    if @customField
      @customField.getOptionByCId(idOption).update('color', color)
    else
      opt = @getOption(idOption)
      opt.color = color
    @render()

  startEditOption: (e) ->
    $el = @$(e.target).closest('.js-list-option')
    if !$el.hasClass('editing')
      $el.addClass('editing')
      $el.children('input[type="text"].js-option').first().select()

  updateOption: (e) ->
    newValue = e.target.value.trim()
    idOption = @$(e.target).closest('.js-list-option').attr('idOption')
    if !@customField
      targetOpt = @getOption(idOption)
      targetOpt.value.text = newValue
    else if @customField.getOptionByCId(idOption).get('value').text != newValue
      @customField.getOptionByCId(idOption).update('value', { text: newValue })
    @render()

  blurOnEnter: (e) ->
    if isSubmitEvent(e)
      @$(e.target).blur()

  removeOption: (e) ->
    idOption = @$(e.target).closest('.js-list-option').attr('idOption')
    targetOpt = @getOption(idOption)
    if @customField
      Confirm.pushView 'delete custom field option',
        elem: e.target
        confirmBtnClass: 'negate'
        fxConfirm: (e) =>
          targetOption = @customField.getOptionByCId(idOption)
          targetOption.destroy()
          @render()
    else
      @options = _.filter @options, (o) -> o.id != idOption
      @render()

  addOption: (e) ->
    if isSubmitEvent(e)
      Util.stop(e)
      newVal = e.target.value.trim()
      if !newVal
        return
      if @customField
        @customField.optionList.create({ value: { text: newVal }, pos: 'bottom' })
      else
        @options.push({
          id: _.uniqueId('field-option_')
          color: 'none'
          new: true
          pos: (_.last(@options)?.pos || 0) + 5
          value:
            text: e.target.value.trim()
        })
      e.target.value = ""
      @render()
      # return focus to new item text box
      @$('.js-add-option').focus()
